/**
 * Created by natalia.petrov on 5/10/2017.
 */
import PropTypes from 'prop-types';

import React from 'react';
import {connect} from 'react-redux';
//import C from '../../constants/app';
import Spinner from '../Spinner';

class Charger extends React.Component {
    render() {
        if (this.props.isFetching) {
            return <Spinner/>
        } else if (this.props.pastDelay) { //for "Loadable" (code splitting)
            return <Spinner/>
        }
        else {
            return null;
        }
    }
}

Charger.propTypes = {
    isFetching: PropTypes.bool.isRequired,
    pastDelay: PropTypes.bool
};

function mapStateToProps(state) {
    return {
        isFetching: state.app.get('IS_FETCHING')
    }
}

export default connect(mapStateToProps)(Charger);



// WEBPACK FOOTER //
// ./components/utils/Charger.js